import React, {useEffect, useMemo} from 'react';

import {ButtonHistoryBack} from 'components/form/actions/button-history-back';
import {EButtonType} from 'entities/metadata';
import {CustomLink} from 'features/provide-custom-link';
import {URL_REQUESTS} from 'shared/constants/urls';
import {ELinkType} from 'shared/types/links';
import {useAppDispatch, useAppSelector} from 'store/config/hooks';
import {selectRequestStatus} from 'store/slices/request-slice/request-selectors';
import {loadRequestStatusesCommentData, loadRequestStatusesData} from 'store/slices/request-slice/request-slice-thunks';
import {IRequestInfo} from 'store/slices/request-slice/request-slice-type';

import {CollapseButton} from '../actions/collapse-button';
import {Buttons} from '../buttons/buttons';
import {ERequestTypeCode} from '../request-form/request-form.constants';

import './status-model-aware-actions.less';

export interface IStatusModelAwareActionsProps {
  removeControlCollapseAction?: boolean;
  requestCommentId?: string;
  requestFormKey: string;
  onClose?: () => void;
  entityName?: string;
  isHidden?: boolean;
  onSubmit?: () => void;
  requestType?: string;
  requestInfo?: IRequestInfo;
  linkExtraData?: Record<string, any>;
}

export const StatusModelAwareActions = ({
    requestCommentId,
    removeControlCollapseAction,
    entityName,
    requestFormKey,
    isHidden,
    onClose,
    onSubmit,
    requestType,
    requestInfo,
    linkExtraData,
}: IStatusModelAwareActionsProps) => {
    const statusesData = useAppSelector(selectRequestStatus(requestFormKey));
    const statuses = statusesData?.statuses;
    const dispatch = useAppDispatch();

    const {ddUrlDto} = requestInfo ?? {};

    useEffect(() => {
        if (!statuses && requestCommentId) {
            if (requestType === ERequestTypeCode.REQUEST_DIT
                || requestType === ERequestTypeCode.MESSAGE
            ) {
                dispatch(
                    loadRequestStatusesCommentData({commentId: requestCommentId, requestFormKey}),
                );
                return;
            }
            dispatch(
                loadRequestStatusesData({commentId: requestCommentId, requestFormKey}),
            );
        }
    }, [requestCommentId, statuses, requestFormKey, requestType]);

    const actions = useMemo(
        () => statuses?.filter(action => statuses?.includes(action)), [statuses, requestCommentId],
    );
    return (
        <div className="buttons">
            {!isHidden && (
                <Buttons
                    requestCommentId={String(requestCommentId)}
                    requestFormKey={requestFormKey}
                    onClose={onClose}
                    actions={actions}
                    entityName={entityName}
                    onSubmit={onSubmit}
                />
            )}
            {removeControlCollapseAction && <CollapseButton />}
            <ButtonHistoryBack
                actionIcon="ArrowBackOutlined"
                buttonType={EButtonType.default}
                url={URL_REQUESTS}
            />
            {ddUrlDto &&
                    <CustomLink
                        key={ddUrlDto.url}
                        link={{
                            url: ddUrlDto?.url ?? '/ais3.doc.journal',
                            urlType: ddUrlDto?.urlType ?? ELinkType.INTERNAL,
                            filterParameters: ddUrlDto?.filterParameters,
                            ignoreRequiredParameters: ddUrlDto?.ignoreRequiredParameters ?? true,
                            linkProperties: ddUrlDto?.linkProperties ?? {
                                title: 'Перейти в реестр документов',
                                icon: 'ContainerOutlined',
                                type: 'button',
                            },
                        }}
                        extraStateData={{
                            aisRegister: {
                                requests: {
                                    requestId: requestInfo?.id,
                                    requestData: {
                                        ...linkExtraData,
                                    },
                                },
                            },
                        }}
                    />
            }
        </div>
    );
};
